import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from '@mui/material';

const PatienceModal = ({
  open,
  title = 'لطفا صبور باشید',
  description = 'این پروسه زمان‌بر است و ممکن است چند دقیقه طول بکشد.',
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      sx={{ direction: 'rtl' }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            py: 2,
            px: 3,
            minWidth: 280,
          }}
        >
          <CircularProgress />
          <Typography fontSize={15} fontWeight={600} textAlign="center">
            {title}
          </Typography>
          <Typography fontSize={13} color="text.secondary" textAlign="center">
            {description}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PatienceModal;
